import React from 'react'
import Label from 'lib/Label'
import "./index.scss"
import { Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { setIsKeyDuplicate ,setDuplicateStatus,clearDuplicateStatus } from 'redux/recursiveReducer';
import { setIsKeyDuplicateGuardian } from 'redux/guardianReducer';
import './index.scss'
import ErrorMessage from 'lib/ErrorMessage';

const EmailComponent = (props) => {
  const {
    placeholder,
    label,
    value,
    onChange,
    rows,
    cols,
    error,
    name,
    size,
    events,
    validators,
    is_disabled,
    isEditable // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  
  } = props;
  const IndirectEval = (evalString) =>{
    return eval(evalString)
  }
  const errActive = error && error?.length !== 0;
    const errorClass = errActive ? "error_outline" : ""
  const currentEmail = useSelector(state=>state?.recursive?.recursiveFormData?.email)
  const existingEmails = useSelector(state => state?.recursive?.saveData)
  const guardianSaveData = useSelector(state=>state?.guardianRecursive?.saveData)
  const editIndex = useSelector(state => state.recursive.editIndex)
  const guardianEditIndex = useSelector(state=>state.guardianRecursive.editIndex)
  const guardianRecursiveFormData = useSelector(state => state.guardianRecursive.recursiveFormData)
  const dispatch = useDispatch()
  const [uniqueDataError, setUniqueDataError] = useState(false)
  const [uniqueDataErrorForGuardian,setUniqueDataErrorForGuardian] = useState(false)
  const isKeyDuplicate = useSelector((state) => 
    Object.values(state?.recursive?.duplicates || {}).some((isDuplicate) => isDuplicate)
  );

  const onKeyUpCapture=async (item)=>{
    if(events){
      IndirectEval(events?.onKeyUpCapture)
    }
   }
  const checkPreviousEnteredEmails = async(id) => {
    setUniqueDataError(false)
    let  isDuplicate = false;
    existingEmails.forEach((item,index)=>{
      if (item[id] === value && index !== editIndex){
        isDuplicate = true;
        setDuplicateStatus('email', isDuplicate);
        dispatch(setDuplicateStatus({ field: "email", isDuplicate: true }));
        setUniqueDataError(true)
      }else{
        setUniqueDataError(false)
        dispatch(clearDuplicateStatus({ field: "email" }));
      }
   })
  }
  const checkPreviousEnteredEmailsForGuardian = async (id) => {
    setUniqueDataErrorForGuardian(false)
    guardianSaveData.forEach((item,index)=>{
      if (guardianRecursiveFormData?.majority === "Major" && item?.majority === "Major" && item[id] === value && index !== guardianEditIndex){
        setUniqueDataErrorForGuardian(true)
      }
   })
  }

  useEffect(() => {
    setUniqueDataErrorForGuardian(false)
    guardianSaveData.forEach((item,index)=>{
      if (guardianRecursiveFormData?.majority === "Major" && item?.majority === "Major" && item[name] === guardianRecursiveFormData[name] && index !== guardianEditIndex){
        setUniqueDataErrorForGuardian(true)
      }
   })
  }, [guardianRecursiveFormData])
  
useEffect(()=>{
    dispatch(setIsKeyDuplicate(isKeyDuplicate))
}, [isKeyDuplicate])
  
useEffect(()=>{
  dispatch(setIsKeyDuplicateGuardian(uniqueDataErrorForGuardian))
},[uniqueDataErrorForGuardian])

  return (
    <>
    <div className={size}>
      <Label label={label} validators={validators} />
      <input
        name={name}
        placeholder={placeholder}
        className={`form-email ${errorClass} ${uniqueDataError ? "duplicate_error" : ""}  ${!isEditable && "radioDisabled"}`}
        value={value || ""}
        onChange={onChange}
        onKeyUpCapture={onKeyUpCapture}
        disabled={eval(is_disabled) ? true : isEditable ? false:true}

      />
        {uniqueDataError ? <span className='duplicate_code_error'>Email should be unique</span> : null} 
       {uniqueDataErrorForGuardian ? <span className='duplicate_code_error'>Email should be unique for Guardians</span> : null} 
        
       {
        error?.length !== 0 && (
            <ErrorMessage error={error} />
        )
    }
    </div>
  
    </>
  );
};

export default EmailComponent